/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { hydrate, unmountComponentAtNode } from 'react-dom';
import fetch from 'isomorphic-fetch';
import { Cookies, CookiesProvider } from 'react-cookie';
import Header from './Header';
import Footer from './Footer';
import OpenHouse from './OpenHouse';
import config from '../../config';

import './styles.scss';

const headerRoot = document.getElementById('backplane-header');
const openHouseModalRoot = document.getElementById('backplane-header-open-house');
const footerRoot = document.getElementById('backplane-footer');

const preloadedState = window.__BACKPLANE_API__; // eslint-disable-line no-underscore-dangle

const fetchBackplane = async () => {
  const cookies = new Cookies();
  const accessToken = cookies.get('access_token');
  const at = accessToken ? `&accessToken=${accessToken}` : '';
  const url = `${config.servicesURL}/backplane/render.json?bundle=margins${at}`;
  const response = await fetch(url);
  const body = await response.json();

  if (response.status === 200) return body;
  throw body;
};

const wrappedHydrate = (entrypointToWrap, rootToRenderTo) =>
  hydrate(<CookiesProvider>{entrypointToWrap}</CookiesProvider>, rootToRenderTo);

const mount = () => {
  if (preloadedState) {
    wrappedHydrate(<Header {...preloadedState} />, headerRoot);
    wrappedHydrate(<Footer {...preloadedState} />, footerRoot);
    wrappedHydrate(<OpenHouse {...preloadedState} />, openHouseModalRoot);
  } else {
    fetchBackplane().then(backplane => {
      wrappedHydrate(<Header {...backplane.data.api} />, headerRoot);
      wrappedHydrate(<Footer {...backplane.data.api} />, footerRoot);
      wrappedHydrate(<OpenHouse {...backplane.data.api} />, openHouseModalRoot);
      document.dispatchEvent(
        new CustomEvent('backplane_loaded', {
          detail: backplane.data.api,
        })
      );
    });
  }
};

mount();

if (module.hot) {
  module.hot.accept(['./Header', './Footer', './OpenHouse'], () => {
    unmountComponentAtNode(headerRoot);
    unmountComponentAtNode(footerRoot);
    unmountComponentAtNode(openHouseModalRoot);
    mount();
  });
}
